import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import letEngineersFocusedPng2x from './assets/LetEngineersFocused@2x.png'
import letEngineersFocusedWebp from './assets/LetEngineersFocused.webp'
import letEngineersFocusedWebp2x from './assets/LetEngineersFocused@2x.webp'
import letEngineersFocusedWebp3x from './assets/LetEngineersFocused@3x.webp'

const LetEngineersFocusedImage = () => {
  return (
    <Picture>
      <source
        type="image/webp"
        srcSet={`${letEngineersFocusedWebp}, ${letEngineersFocusedWebp2x} 2x, ${letEngineersFocusedWebp3x} 3x`}
      />
      <Image
        width="616"
        height="488"
        src={letEngineersFocusedPng2x}
        alt="Illustration: Let Engineers Focused on Product"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default LetEngineersFocusedImage
